import { render } from "./NewRequest.vue?vue&type=template&id=4ac3922a"
import script from "./NewRequest.vue?vue&type=script&lang=js"
export * from "./NewRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__